import AdSlot from "./AdSlot";

export default function SidebarAd({ articleSlug, className = "" }) {
  return (
    <AdSlot
      placement="sidebar"
      articleSlug={articleSlug}
      className={`hidden lg:block ${className}`}
    />
  );
}
